import { render, staticRenderFns } from "./UpdateInventory.vue?vue&type=template&id=502aed40&scoped=true"
import script from "./UpdateInventory.vue?vue&type=script&lang=js"
export * from "./UpdateInventory.vue?vue&type=script&lang=js"
import style0 from "./UpdateInventory.vue?vue&type=style&index=0&id=502aed40&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502aed40",
  null
  
)

export default component.exports